import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout/Layout";
import Home from "@/pages/Home";
import QuienesSomos from "@/pages/QuienesSomos";
import Impacto from "@/pages/Impacto";
import Voluntariado from "@/pages/Voluntariado";
import Transparencia from "@/pages/Transparencia";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contacto from "@/pages/Contacto";
import Donar from "@/pages/Donar";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: { fontFamily: "Manrope, system-ui, sans-serif" },
                    }}
                />
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/quienes-somos" element={<QuienesSomos />} />
                        <Route path="/impacto" element={<Impacto />} />
                        <Route path="/voluntariado" element={<Voluntariado />} />
                        <Route path="/transparencia" element={<Transparencia />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="/donar" element={<Donar />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
